import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

export default function DemoCarousel({ images, height }) {
	return (
		<Carousel showArrows={true} showThumbs={false} >
			{images.map((image, index) => (
				<div key={index} style={{ height: height || '330px', background: 'white', position: 'relative' }}>
					<div
						style={{
							backgroundImage: `url(${image})`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center',
							backgroundSize: 'cover',
							height: '100%',
							width: '100%',
						}}
					/>
				</div>
			))}
		</Carousel>
	);
}
